import React from "react";
import NavDesktop from "./nav-desktop";
import NavMobile from "./nav-mobile";
import { useWindowSize } from "../../../hooks/windowSize";

export default function Navbar({ header, navBg }) {
  const { width } = useWindowSize();
  // let lastScrollValue = 0;
  // let lastNavView = 0;
  // const onScroll = (e) => {
  //   let scrollValue = window.pageYOffset || e.target.documentElement.scrollTop;
  //   if (scrollValue < 30) {
  //     document.getElementById("main-nav").style.top = "0px";
  //     document.getElementById("main-nav").style.opacity = "1";
  //   } else if (scrollValue > 150) {
  //     document.getElementById("main-nav").style.top = "-200px";
  //     document.getElementById("main-nav").style.opacity = "0";
  //   }
  // if (scrollValue > lastScrollValue) {
  //   if (scrollValue > 20) {
  //     document.getElementById("main-nav").style.top = "-200px";
  //     lastNavView = scrollValue;
  //   }
  // } else {
  //   if (scrollValue < lastNavView - 140) {
  //     document.getElementById("main-nav").style.top = "0px";
  //   }
  // }
  // lastScrollValue = scrollValue <= 0 ? 0 : scrollValue;
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", onScroll, false);
  //   return () => window.removeEventListener("scroll", onScroll);
  // }, []);

  if (width === 0) return <></>;
  return width > 767 ? (
    <NavDesktop header={header} navBg={navBg} />
  ) : (
    <NavMobile header={header} />
  );
}
